module.exports = __webpack_public_path__ + "img/activity3.f21c9670.png";